module.exports = __webpack_public_path__ + "img/acryprint_info1.d7f01e32.png";